import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { SensorTypeConfig } from 'src/app/_shared/models/sensor-type-config';
import { SensorTypesService } from 'src/app/public-utility/sensor-types/services/sensor-types.service';

@Injectable({
  providedIn: 'root',
})
export class SensorTypeConfigResolver implements Resolve<SensorTypeConfig> {
  constructor(private sensorsTypesService: SensorTypesService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<SensorTypeConfig> {
    const id = Number(route.params.id);
    return this.sensorsTypesService.getSensorTypeConfig(id);
  }
}
